module.exports = __webpack_public_path__ + "static/img/8.68e9835.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/9/sp/8.png
// module id = veme
// module chunks = 0